import { IAnalyticsService } from "./IEventTrackingService";
import { ButtonAttributes, LinkAttributes, PageViewAttributes } from "./interfaces";

export class AnalyticsManager {
    
  constructor(private analyticsService: IAnalyticsService) {
  }

  /**
   * Tracks page loads.
   * @param {string} pageName The name of the page being loaded.
   */
  trackPageLoad(attributes: PageViewAttributes): void {
    this.analyticsService.logPageView(attributes);
  }

  /**
   * Identifies a user by email.
   * @param {string} email The email of the user.
   */
  identifyUserByEmail(email: string): void {
    this.analyticsService.identifyUser({ email });
  }

  /**
   * Identifies a user by device ID.
   * @param {string} deviceId The device ID of the user.
   */
  identifyUserByDeviceId(deviceId: string): void {
    this.analyticsService.identifyUser({ deviceId });
  }

  /**
   * Updates user properties.
   * @param {Record<string, any>} properties The properties to update.
   */
  updateUserProperties(properties: Record<string, any>): void {
    this.analyticsService.updateUserProperties(properties);
  }

  /**
   * Logs a custom event.
   * @param {string} event The name of the event.
   * @param {Record<string, any>} properties Optional properties for the event.
   */
  logEvent(event: string, properties?: Record<string, any>): void {
    this.analyticsService.logEvent(event, properties);
  }

  /**
   * Tracks a button click event.
   * @param {Record<string, any>} attributes The attributes of the button being clicked.
   */
  logButtonClick(attributes: ButtonAttributes): void {
    this.analyticsService.logButtonClick(attributes);
  }

  /**
   * Tracks a link click event.
   * @param {Record<string, any>} attributes The attributes of the link being clicked.
   */
  logLinkClick(attributes: LinkAttributes): void {
    this.analyticsService.logLinkClick(attributes);
  }
}

 
